import { DSP_BRAND, DSP_EXPERIENCE } from '../components/internal/constants';
import { NewLaneEvent } from './NewLaneEvent';
import { CLICKSTREAM_EVENT_TYPE } from './clickStreamEventSchema';
import { formNewLaneEventPayload } from './newLaneEventPayload'; // Event handlers

export var action = function action(_ref) {
  var eventData = _ref.eventData,
      newLaneEventData = _ref.newLaneEventData,
      additionalClickStreamData = _ref.additionalClickStreamData,
      onAction = _ref.onAction,
      actionLink = _ref.actionLink,
      gaEngagementAction = _ref.gaEngagementAction,
      gaEngagementCategory = _ref.gaEngagementCategory,
      gaEngagementLabel = _ref.gaEngagementLabel;
  var oldDspPayload = {
    brand: DSP_BRAND,
    experience: DSP_EXPERIENCE,
    sharedJsonStr: JSON.stringify(Object.assign({
      event_type: 'interaction',
      interaction_type: 'click'
    }, eventData))
  };
  var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.INTERACTION, newLaneEventData, additionalClickStreamData);

  if (gaEngagementCategory) {
    var gaPayload = {
      category: gaEngagementCategory,
      action: gaEngagementAction,
      label: gaEngagementLabel
    };
    NewLaneEvent(oldDspPayload, newLanePayload, gaPayload);
  } else {
    NewLaneEvent(oldDspPayload, newLanePayload);
  }

  onAction === null || onAction === void 0 ? void 0 : onAction();

  if (actionLink) {
    window.open(actionLink, '_blank');
  }
};
export var close = function close(_ref2) {
  var eventData = _ref2.eventData,
      newLaneEventData = _ref2.newLaneEventData,
      additionalClickStreamData = _ref2.additionalClickStreamData,
      onClose = _ref2.onClose,
      gaCloseCategory = _ref2.gaCloseCategory,
      gaCloseAction = _ref2.gaCloseAction,
      gaCloseLabel = _ref2.gaCloseLabel;
  var oldDspPayload = {
    brand: DSP_BRAND,
    experience: DSP_EXPERIENCE,
    sharedJsonStr: JSON.stringify(Object.assign({
      event_type: 'interaction',
      interaction_type: 'close'
    }, eventData))
  };
  var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.CLOSE, newLaneEventData, additionalClickStreamData);

  if (gaCloseCategory) {
    var gaPayload = {
      category: gaCloseCategory,
      action: gaCloseAction,
      label: gaCloseLabel
    };
    NewLaneEvent(oldDspPayload, newLanePayload, gaPayload);
  } else {
    NewLaneEvent(oldDspPayload, newLanePayload);
  }

  onClose === null || onClose === void 0 ? void 0 : onClose();
};
export var hover = function hover(_ref3) {
  var eventData = _ref3.eventData,
      newLaneEventData = _ref3.newLaneEventData,
      additionalClickStreamData = _ref3.additionalClickStreamData,
      gaHoverCategory = _ref3.gaHoverCategory,
      gaHoverAction = _ref3.gaHoverAction,
      gaHoverLabel = _ref3.gaHoverLabel;
  var oldDspPayload = {
    brand: DSP_BRAND,
    experience: DSP_EXPERIENCE,
    sharedJsonStr: JSON.stringify(Object.assign({
      event_type: 'interaction',
      interaction_type: 'hover'
    }, eventData))
  };
  var newLanePayload = formNewLaneEventPayload(CLICKSTREAM_EVENT_TYPE.HOVER, newLaneEventData, additionalClickStreamData);

  if (gaHoverCategory) {
    var gaPayload = {
      category: gaHoverCategory,
      action: gaHoverAction,
      label: gaHoverLabel
    };
    NewLaneEvent(oldDspPayload, newLanePayload, gaPayload);
  } else {
    NewLaneEvent(oldDspPayload, newLanePayload);
  }
};